export default "__VITE_ASSET__xPF_JUm5__"